export const MODULE_TYPE = {
  WIKI: "wiki",
  TRACK: "track",
}
